import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _slicedToArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import addOrUpdate from './add-or-update';
import { listUrlFn, sysInfoFn as _sysInfoFn, exportData as _exportData, searchStaffFn } from '@/api/org/per';
import { deleteStaffFun, getInviteStaffData, getStaffAuditResign as _getStaffAuditResign } from '@/api/org/staff';
import { getAvatar } from '@/util/util';
import { getAllListFn as _getAllListFn } from 'api/org/position';
import depTree from '@/components/dep-tree';
// 调整部门
import depAdjust from './dep-adjust';
// 批量倒入修改
import uploadTab from './uploadTab';
// 一键邀请
import invite from './invite';
import exportList from './export.vue';
import leaveOffice from './leaveOffice.vue';
import store from 'storejs';
export default {
  components: {
    addOrUpdate: addOrUpdate,
    depTree: depTree,
    depAdjust: depAdjust,
    uploadTab: uploadTab,
    invite: invite,
    exportList: exportList,
    leaveOffice: leaveOffice
  },
  data: function data() {
    return {
      successImg: require('@/assets/img/success_icon.png'),
      noImportantImg: require('@/assets/img/noImportant_icon.png'),
      cancelImg: require('@/assets/img/cancel-icon.png'),
      tableSelectArr: [],
      posiOptions: [],
      dataForm: {},
      date: '',
      pageSizes: [100, 50, 20],
      isDepAdjust: false,
      page: {
        list: [],
        currPage: 1,
        limit: 100,
        total: 0
      },
      sort: '',
      dir: '',
      tableLoading: false,
      isAddOrUpdate: false,
      popover: false,
      depInfo: {},
      posiAllList: [],
      sysInfoArr: {
        state: [],
        // 在职状态 1-在职 2-离职 3-待离职 4-停职
        salary_method: [],
        // 发薪方式
        settlement_type: [],
        // 结算类型
        formal: [] // 员工属性
      },

      // 俩分钟内不可重复邀请
      dsInvite: false,
      isInvite: false,
      isLeaveOffice: false,
      operateType: '',
      NoRegisterNum: 0,
      staffInfo: {},
      supLoading: false,
      supOptions: [],
      getAvatar: getAvatar
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    contentViewHeight: function contentViewHeight(state) {
      return state.settings.contentViewHeight;
    }
  })), {}, {
    tableHeight: function tableHeight() {
      return this.contentViewHeight - 260;
    }
  }),
  mounted: function mounted() {
    this.sysInfoFn();
    this.getAllListFn();
    this.getTableData();
    this.getNoRegisterNum();
    this.handleCountDown();
  },
  methods: {
    // 倒计时邀请 2分钟之内无法再次邀请
    handleCountDown: function handleCountDown() {
      var _this = this;
      var time = store.get('invalid-time');
      var loop = setInterval(function () {
        _this.dsInvite = Date.now() - time < 120000;
        if (!_this.dsInvite) clearInterval(loop);
      }, 1000);
    },
    // 排序
    handlerSort: function handlerSort(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      this.sort = prop;
      this.dir = order;
      this.getTableData();
    },
    // 数据导出
    batchExport: function batchExport() {
      this.$refs.exportList.init();
    },
    exportData: function exportData(columns) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _ref2, _ref3, begin_hire_date, end_hire_date, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _ref2 = _this2.date || [null, null], _ref3 = _slicedToArray(_ref2, 2), begin_hire_date = _ref3[0], end_hire_date = _ref3[1];
              _context.next = 3;
              return _exportData(_objectSpread(_objectSpread({}, _this2.dataForm), {}, {
                begin_hire_date: begin_hire_date,
                end_hire_date: end_hire_date,
                columns: columns
              }));
            case 3:
              res = _context.sent;
              window.location.href = res.data.down_load_excel.object_url;
              _this2.$refs.exportList.visible = false;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 表格选择
    tableSelectHandle: function tableSelectHandle(val) {
      this.tableSelectArr = val;
    },
    // 部门人员 调整部门
    depAdjustHandle: function depAdjustHandle() {
      var _this3 = this;
      this.isDepAdjust = true;
      this.$nextTick(function () {
        return _this3.$refs.depAdjust.init(_this3.tableSelectArr.map(function (v) {
          return v.staff_id;
        }));
      });
    },
    // 批量导入
    openUpload: function openUpload() {
      this.$refs.uploadTab.init();
    },
    sysInfoFn: function sysInfoFn() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _sysInfoFn();
            case 2:
              res = _context2.sent;
              if (res && res.code === 1) _this4.sysInfoArr = res.data;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    handleNodeClick: function handleNodeClick(val) {
      this.depInfo.name = val.department_name;
      this.dataForm.department_id = val.department_id;
      this.popover = false;
    },
    remoteMethod: function remoteMethod(query) {
      var obj = this.posiAllList.filter(function (v) {
        return v.job_title_name.toLowerCase().indexOf(query.toLowerCase()) > -1;
      });
      this.posiOptions = query !== '' ? obj : [];
    },
    getAllListFn: function getAllListFn() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _getAllListFn();
            case 2:
              res = _context3.sent;
              _this5.posiAllList = res.data;
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getTableData: function getTableData() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _ref4, _ref5, begin_hire_date, end_hire_date, res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _ref4 = _this6.date || [null, null], _ref5 = _slicedToArray(_ref4, 2), begin_hire_date = _ref5[0], end_hire_date = _ref5[1];
              _this6.tableLoading = true;
              _context4.next = 4;
              return listUrlFn(_objectSpread(_objectSpread({}, _this6.dataForm), {}, {
                page: _this6.page.currPage,
                page_size: _this6.page.limit,
                begin_hire_date: begin_hire_date,
                sort: _this6.sort,
                // 排序相关
                dir: _this6.dir,
                end_hire_date: end_hire_date
              }));
            case 4:
              res = _context4.sent;
              _this6.tableLoading = false;
              if (res && res.code === 1) {
                _this6.page.list = res.data.rows;
                _this6.$nextTick(function () {
                  _this6.$refs.tableList && _this6.$refs.tableList.doLayout();
                });
                _this6.page.total = res.data.total_count;
              }
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    // 每页条数
    sizeChangeHandle: function sizeChangeHandle(val) {
      this.page.limit = val;
      this.getTableData();
    },
    // 切换 页
    currentChangeHandle: function currentChangeHandle(val) {
      this.page.currPage = val;
      this.getTableData();
    },
    addOrUpdate: function addOrUpdate(item) {
      var _this7 = this;
      this.operateType = !item ? 'create' : 'edit';
      this.isAddOrUpdate = true;
      this.$nextTick(function () {
        _this7.$refs.addOrUpdate.init(item || null);
      });
    },
    view: function view(item) {
      var _this8 = this;
      this.operateType = 'view';
      this.isAddOrUpdate = true;
      this.$nextTick(function () {
        _this8.$refs.addOrUpdate.init(item || null);
      });
    },
    departmentClear: function departmentClear() {
      this.dataForm.department_id = null;
    },
    // 是否有离职审批流
    getStaffAuditResign: function getStaffAuditResign(item) {
      var _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var res;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this9.staffInfo = {
                staff_id: item.staff_id,
                staff_name: item.staff_name,
                formal_name: item.formal_name,
                hire_date: item.hire_date
              };
              _context5.next = 3;
              return _getStaffAuditResign({
                staff_id: item.staff_id
              });
            case 3:
              res = _context5.sent;
              if (res.data) {
                _this9.$confirm(_this9.$t('2000'), _this9.$t('229'), {
                  confirmButtonText: _this9.$t('131'),
                  cancelButtonText: _this9.$t('66')
                  // type: 'warning'
                }).then(function () {
                  _this9.leaveOffice(_this9.staffInfo);
                });
              } else {
                _this9.leaveOffice(_this9.staffInfo);
              }
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    // 离职
    leaveOffice: function leaveOffice() {
      var _this10 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this10.isLeaveOffice = true;
              _this10.$nextTick(function () {
                return _this10.$refs.leaveOffice.init(_this10.staffInfo || null);
              });
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    // 删除
    deleteStaff: function deleteStaff(staffInfo) {
      var _this11 = this;
      this.$confirm(this.$t('confirm_delete'), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(function () {
        deleteStaffFun(staffInfo).then(function () {
          _this11.$notify({
            title: _this11.$t('229'),
            message: _this11.$t('806'),
            type: 'success'
          });
          _this11.getTableData();
        });
      });
    },
    invite: function invite() {
      var _this12 = this;
      if (this.dsInvite) return;
      this.isInvite = true;
      this.$nextTick(function () {
        return _this12.$refs.invite.init();
      });
    },
    getNoRegisterNum: function getNoRegisterNum() {
      var _this13 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return getInviteStaffData().then(function (res) {
                if (res && res.code === 1) {
                  _this13.NoRegisterNum = res.data.no_register_staff_count;
                }
              });
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    // 数据导出
    exportNoRegister: function exportNoRegister() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var res;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return _exportData({
                is_register_user: 0
              });
            case 2:
              res = _context8.sent;
              window.location.href = res.data.down_load_excel.object_url;
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    // 直线上级搜索
    supRemoteMethod: function supRemoteMethod(query) {
      var _this14 = this;
      if (query !== '') {
        this.supLoading = true;
        // ajax请求
        clearTimeout(this.timer);
        this.timer = setTimeout(function () {
          searchStaffFn({
            search_name: query,
            page_size: 20
          }).then(function (res) {
            _this14.supLoading = false;
            if (res && res.code === 1) {
              _this14.supOptions = res.data;
            }
          });
        }, 300);
      } else {
        this.supOptions = [];
      }
    }
  }
};